import { fetch } from 'utils/redux/action'

// ------------------------------------
// Constants
// ------------------------------------
export const FETCH_CRYPTO_CURRENCIES = 'FETCH_CRYPTO_CURRENCIES'
export const RECEIVE_CRYPTO_CURRENCIES = 'RECEIVE_CRYPTO_CURRENCIES'

// ------------------------------------
// Actions
// ------------------------------------
export const actionTypes = {
	fetch: FETCH_CRYPTO_CURRENCIES,
	receive: RECEIVE_CRYPTO_CURRENCIES
}

// ------------------------------------
// Thunk
// ------------------------------------
export const fetchCryptoCurrencies = () => fetch('cryptoCurrencies', 'cryptocurrencies', actionTypes)
